export const getLinkForCurrentHost = (path: string): string => {
    return `${window.location.protocol}//${window.location.host}${path}`
}